export default "__VITE_ASSET__DJqjOlgg__"